export default __webpack_public_path__ + "static/hero-ultimate-sport-e4b626d5bea4322e6700cadebc184c24.jpg";